import { EmailVerificationRequestDto, UserDto } from '../dtos/user';
import { EmailVerifyRequest, User } from '../models/user';
import { isAutoGeneratedEmail } from '../../utils/componentHelpers';

export const dtoToUser = (user: UserDto): User => {
  const { name, careem_user_id, city, email, phone } = user;
  const isEmailVerified = !isAutoGeneratedEmail(email);
  return {
    name,
    userId: careem_user_id,
    city,
    email,
    phone,
    isEmailVerified
  };
};

export const dtoToEmailVerificationRequest = (request: EmailVerificationRequestDto): EmailVerifyRequest => {
  const { success, message, errorCode } = request;
  return {
    isSuccess: success,
    message,
    errorCode
  };
};
